import { UnitStateV2 } from '@eppendorf/vnls-device-service-utils';

import i18next from '$shared/i18n/i18n';

export function getActivityStatusText(activityStatus: UnitStateV2 | null): string {
  switch (activityStatus) {
    case UnitStateV2.AutomaticallyRunning:
      return i18next.t('translation:activityStatus.automaticallyRunning');
    case UnitStateV2.Done:
      return i18next.t('translation:activityStatus.done');
    case UnitStateV2.Error:
      return i18next.t('translation:activityStatus.error');
    case UnitStateV2.Idle:
      return i18next.t('translation:activityStatus.idle');
    case UnitStateV2.ManuallyRunning:
      return i18next.t('translation:activityStatus.manuallyRunning');
    case UnitStateV2.Paused:
      return i18next.t('translation:activityStatus.paused');
    case UnitStateV2.Offline:
      return i18next.t('translation:activityStatus.offline');
    case UnitStateV2.Online:
      return i18next.t('translation:activityStatus.online');
    case UnitStateV2.Hold:
      return i18next.t('translation:activityStatus.hold');
    case UnitStateV2.Running:
      return i18next.t('translation:activityStatus.running');
    case UnitStateV2.Unreachable:
      return i18next.t('translation:activityStatus.unreachable');
    case UnitStateV2.Preparing:
      return i18next.t('translation:activityStatus.preparing');
    default:
      return '';
  }
}
